export var PLACEMENT_TOP_START = 'top-start';
export var PLACEMENT_TOP_END = 'top-end';
export var PLACEMENT_BOTTOM_START = 'bottom-start';
export var PLACEMENT_BOTTOM_END = 'bottom-end';
export var PLACEMENT_RIGHT_START = 'right-start';
export var PLACEMENT_RIGHT_END = 'right-end';
export var PLACEMENT_LEFT_START = 'left-start';
export var PLACEMENT_LEFT_END = 'left-end';


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/esm/constants/popper.js
// module id = KXmT
// module chunks = 52